webpackJsonp([76042757312351],{

/***/ 695:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mount Olives."}},"markdownRemark":{"id":"/opt/build/repo/src/pages/events/2100-01-02/index.md absPath of file >>> MarkdownRemark","html":"<h2>Lobpreis - Anbetung - Gebet</h2>\n<h3>Regelmäßiges Gebetstreffen der Mt. Olives Gruppe</h3>\n<p>Normalerweise treffen wir uns jeden 2. Dienstag. <br/>\nZu Lobpreis, Anbetung, Fürbitte und Gebet.<br/>\nWie der Geist Gottes uns führt.</p>\n<p><strong><em>verschiedene Orte, daher bitte bei Interesse anrufen</em></strong> (073879845270)</p>","frontmatter":{"title":"Mt.Olives betet","description":"unser zweiwöchentliches Morgengebet","date":"May 01, 2115","displayDate":"dienstags, 9:00 Uhr","location":"wechselt (bitte nachfragen)"}}},"pathContext":{"slug":"/events/2100-01-02/","previous":{"fields":{"slug":"/events/2100-01-03/"},"frontmatter":{"title":"Mt.Olives liest die Bibel"}},"next":{"fields":{"slug":"/events/2100-01-01/"},"frontmatter":{"title":"Mt.Olives Pur"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---events-2100-01-02-a86aa1205b6f1384e9f2.js